// extracted by mini-css-extract-plugin
export default {"container":"CustomSection_container__-kuZL"};